import { OnDestroy } from '@angular/core';
import { ChangeDetectorRef, Component, Inject, NgZone, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { v4 as uuidv4 } from 'uuid';
import { WindowRefService } from 'src/app/services/window-ref.service';
import { AnyAaaaRecord } from 'dns';
import { CustomConfirmDialogComponent } from '../custom-confirm-dialog/custom-confirm-dialog.component';
import { environment } from 'src/environments/environment';
declare var google:any;
declare var Razorpay: any;
@Component({
  selector: 'sm-create-new-business',
  templateUrl: './create-new-business.component.html',
  styleUrls: ['./create-new-business.component.scss']
})
export class CreateNewBusinessComponent implements OnInit, OnDestroy {


  private _apiSubscription: Subscription = new Subscription();
  noOfMonths: number = 1
  public newBusinessObj: any = {
    name: null,
    phone: null,
    entityType: null,
    entityDesc: null,
    referenceNo: null,
    ownerName: null,
    ownerPhone: null,
    entityStatus: 1,
    isMediaOnly: 0,
    addressInfo: {
      addressLine: null
    }
  }
  tochecksalon:boolean = false
  tocheckbeautyparlour:boolean = false
  tocheckspa:boolean = false
  tocheckmakeup:boolean = false
  
  entitySubscriptionHistoryData: any = []
  plansList:any = []
  editmode: boolean = false
  constructor(private _apiService: ApiService, @Inject(MAT_DIALOG_DATA) public parentData: any,  private ngZone : NgZone, private loaderService: LoaderServiceService, private winRef: WindowRefService, private cdr: ChangeDetectorRef, private dialog: MatDialog) {

    if(this.parentData.data && this.parentData.data != null){
      console.log("data:::::::", this.parentData.data);
      this.editmode = true
      this.toShowExistingPlans = false
      this.toShowPlatformPlans = false

      this.newBusinessObj.name = this.parentData.data[0].entityName
      // this.newBusinessObj.entityType = this.parentData.data[0].entityName
      this.newBusinessObj.addressInfo = this.parentData.data[0].addressInfo
      this.newBusinessObj.addressInfo.addressLine = this.parentData.data[0].addressInfo.address_line
      this.newBusinessObj.entityDesc = this.parentData.data[0].entityDesc
      this.newBusinessObj.phone = this.parentData.data[0].entityPhone
      this.newBusinessObj.ownerName = this.parentData.data[0].ownerName
      this.newBusinessObj.ownerPhone = this.parentData.data[0].ownerPhone
      this.newBusinessObj.referenceNo = this.parentData.data[0].referenceNo


      if(this.parentData.data[0].entityType == '1'){
        this.tochecksalon = true
        this.serviceType.push('Salon');
      }else if(this.parentData.data[0].entityType == '2'){
        this.tocheckbeautyparlour = true
        this.serviceType.push('Beauty Parlour');
      }else if(this.parentData.data[0].entityType == '3'){
        this.tocheckspa = true
        this.serviceType.push('Spa');
      }else if(this.parentData.data[0].entityType == '4'){
        this.tocheckmakeup = true
        this.serviceType.push('Makeup Artist');
      }else if(this.parentData.data[0].entityType == '5'){
        this.tochecksalon = true
        this.tocheckbeautyparlour = true
        this.serviceType.push('Salon');
        this.serviceType.push('Beauty Parlour');
      }else if(this.parentData.data[0].entityType == '6'){
        this.tochecksalon = true
        this.tocheckspa = true
        this.serviceType.push('Salon');
        this.serviceType.push('Spa');
      }else if(this.parentData.data[0].entityType == '7'){
        this.tochecksalon = true
        this.tocheckmakeup = true
        this.serviceType.push('Salon');
        this.serviceType.push('Makeup Artist');
      }else if(this.parentData.data[0].entityType == '8'){
        this.tocheckbeautyparlour = true
        this.tocheckspa = true
        this.serviceType.push('Beauty Parlour');
        this.serviceType.push('Spa');
      }else if(this.parentData.data[0].entityType == '9'){
        this.tocheckbeautyparlour = true
        this.tocheckmakeup = true
        this.serviceType.push('Beauty Parlour');
        this.serviceType.push('Makeup Artist');
      }else if(this.parentData.data[0].entityType == '10'){
        this.tocheckspa = true
        this.tocheckmakeup = true
        this.serviceType.push('Spa');
        this.serviceType.push('Makeup Artist');
      }else if(this.parentData.data[0].entityType == '11'){
        this.tochecksalon = true
        this.tocheckbeautyparlour = true
        this.tocheckspa = true
        this.serviceType.push('Salon');
        this.serviceType.push('Beauty Parlour');
        this.serviceType.push('Spa');
      }else if(this.parentData.data[0].entityType == '12'){
        this.tochecksalon = true
        this.tocheckbeautyparlour = true
        this.tocheckmakeup = true
        this.serviceType.push('Salon');
        this.serviceType.push('Beauty Parlour');
        this.serviceType.push('Makeup Artist');
      }else if(this.parentData.data[0].entityType == '13'){
        this.tochecksalon = true
        this.tocheckspa = true
        this.tocheckmakeup = true
        this.serviceType.push('Salon');
        this.serviceType.push('Spa');
        this.serviceType.push('Makeup Artist');
      }else if(this.parentData.data[0].entityType == '14'){
        this.tocheckbeautyparlour = true
        this.tocheckspa = true
        this.tocheckmakeup = true
        this.serviceType.push('Beauty Parlour');
        this.serviceType.push('Spa');
        this.serviceType.push('Makeup Artist');
      }else if(this.parentData.data[0].entityType == '15'){
        this.tochecksalon = true
        this.tocheckbeautyparlour = true
        this.tocheckspa = true
        this.tocheckmakeup = true
        this.serviceType.push('Salon');
        this.serviceType.push('Beauty Parlour');
        this.serviceType.push('Spa');
        this.serviceType.push('Makeup Artist');
      }

      this.homeServiceAvailable = this.parentData.data[0].homeServiceStatus == 1 ? true : false
      this.shopServiceAvailable = this.parentData.data[0].shopServiceStatus == 1 ? true : false


      // this.newBusinessObj.name = this.parentData.data.entityName
      // this.newBusinessObj.name = this.parentData.data.entityName
      // this.newBusinessObj.name = this.parentData.data.entityName
      // this.newBusinessObj.name = this.parentData.data.entityName
      // this.newBusinessObj.name = this.parentData.data.entityName

      this.toShowForm = true


      
    }else {
      this.loaderService.showLoader = true
      this._apiService.getSubcriptionHistoryById(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID), '0',this.countryInfo.countryCode)
      this._apiService.getPlansList()
    }
   }
   countryInfo:any = typeof sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT) == 'string' ? JSON.parse(sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)!) : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)
  
  ngOnInit(): void {
    
    

    this._apiSubscription =  this._apiService.apiResult.subscribe((resData) => {

      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_SUBSCRIPTION_HISTORY_BY_ID){ 
        this.entitySubscriptionHistoryData = []

          if(resData.result){
            console.log(this.paymentResponse);
            
            if(this.paymentResponse && this.paymentResponse != null){
              console.log("hitting null correct");
              
              resData.result.forEach((element:any) => {
                this.entitySubscriptionHistoryData.push(element)
              });
              this.selectedPlan = [this.entitySubscriptionHistoryData[0]]

            }else{
              console.log("hitting null wrong");
              resData.result.forEach((element:any) => {
                this.entitySubscriptionHistoryData.push(element)
              });
              this.toShowExistingPlans = true
            }
            
          }else{
            this.toShowPlatformPlans = true
            this.toShowMonths = false
            this.noOfMonths = 1
          }
          this.loaderService.showLoader = false
          
      }
      if(resData.responseType === SM_CONSTANTS.UPDATE_ENTITY_INFO_RESULT){ 
       if(resData.result){

        if(this.editmode){
          this.loaderService.showLoader = false
          this.parentData.ref.closeAll();
        }
        else{
          localStorage.setItem('newlyCreatedBusinessHash', resData.result.hash_id)
          let data = {
            subscriptionInfo : {  
              fromDate: this.formatDateString(new Date()), 
              toDate: this.addDaysToDate(new Date(), typeof this.selectedPlan[0].validity == 'string' ? +this.selectedPlan[0].validity.split(' ')[0] : this.selectedPlan[0].validity),  
              oldEntitySubscriptionActHash: "",
              subscriptionStatus: ""
            }
          }
          // this._apiService.updateEntitySubsciptionInfo(resData.result.hash_id, this.selectedPlan[0].hash_id,data)
         }
        }

       
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_SUBSCRIPTION_INFO){ 
       if(resData.result){
        this.paymentResponse = null
        this.loaderService.showLoader = false
        this.parentData.ref.closeAll();
       }
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_PLANS_LIST){ 
        this.plansList = []
       if(resData.result){
        resData.result.forEach((element:any) => {
          if(element.eligibilityType == 1){
            element.selected = false
            this.plansList.push(element)
          }
        });
       }
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_CREATE_SUBSCRIPTION_ORDER){ 
        
       if(resData.result){
        this.payWithRazor(resData.result.id, resData.result.amount*100);
       }
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_VALIDATE_PAYMENT_SIGNATURE){ 
        
       if(resData.result){
        if(resData.result.signatureIsValid == "true"){
          console.log(this.selectedPlan);
          console.log(+this.selectedPlan[0].validity.split(' ')[0]);
          
          let data = {
            transactionInfo: {
              planHash	:	this.selectedPlan[0].hash_id,
              noOfUsers	:	0,
              noOfEntity	:	1,
              fromDate	:	this.formatDateString(new Date()),
              toDate	:	this.addDaysToDate(new Date(), (+this.selectedPlan[0].validity.split(' ')[0])*this.noOfMonths),
              validity	:	(+this.selectedPlan[0].validity.split(' ')[0])*this.noOfMonths,
              totalCost	:	(this.selectedPlan[0].perUnitCost)*this.noOfMonths,
              unitCost	:	this.selectedPlan[0].perUnitCost,
              paymentType	:	1,
              paymentRef	:	this.paymentResponse.razorpay_payment_id,
              currency: this.selectedPlan[0].currency,
              currencySymbol: this.selectedPlan[0].currency_symbol,

            }
          }

          this._apiService.updatePaymentRecord(data)
        }
       }
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_PAYMENT_RECORD){ 
        console.log(this.toShowPlatformPlans, this.toShowForm);
       if(resData.result){
        this.toShowPlatformPlans = false
        this.toShowForm = true
        const myButton = document.getElementById('toClick'); 
        this.simulateMouseClick(myButton);
        // this.parentData.ref.closeAll();
        console.log(this.toShowPlatformPlans, this.toShowForm);
        this._apiService.getSubcriptionHistoryById(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID), '0',this.countryInfo.countryCode)
        this.toShowMonths = false
        this.noOfMonths = 1
       }
      }
    })

  }
  selectedPlan: any = []
  toShowForm: boolean = false
  toShowExistingPlans: boolean = false
  toShowPlatformPlans: boolean = false
  createBusinessWithExistingSubs(item:any){
    // if(confirm("Are you sure you want to add the business on this subscription?")){
    //   this.selectedPlan = []
    //   this.selectedPlan.push(item)
    //   this.toShowForm = true
    //   this.toShowExistingPlans = false
    // }

    const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
      data : {
        title : 'Alert',
        message : 'Are you sure you want to add the business on this subscription?',
        okbtn : 'Confirm',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe(result=>{
      console.log(result);
      if(result){ 
        this.selectedPlan = []
      this.selectedPlan.push(item)
      this.toShowForm = true
      this.toShowExistingPlans = false
      }
    })

  


  }
  serviceType: any = []
  clickTypeCheckbox(event:any){
    if(event.checked){
      this.serviceType.push(event.source.value)
    }
    else if(!event.checked){
      const index = this.serviceType.findIndex( (x:any)=>x == event.source.value);
      this.serviceType.splice(index,1)
    }

    console.log(this.serviceType);
    
    
  }
  addNewSubs(){
    
    this.toShowExistingPlans = false
    this.toShowPlatformPlans = true
    this.toShowMonths = false
    this.noOfMonths = 1
  }
  
  clickAvailabilityCheckbox(event:any){
    if(event.checked){
      this.newBusinessObj.entityStatus = 1
    }else if(!event.checked){
      this.newBusinessObj.entityStatus = 0
    }
  }
  homeServiceAvailable: boolean = false
  shopServiceAvailable: boolean = false
  clickServiceAvailabilityCheckbox(event:any, type:any){
    if(event.checked){
      if(type == 0){
        this.homeServiceAvailable = true
      }else if(type == 1){
        this.shopServiceAvailable = true
      }
    }else if(!event.checked){
      if(type == 0){
        this.homeServiceAvailable = false
      }else if(type == 1){
        this.shopServiceAvailable = false
      }
    }
  }

  goBack(){
    this.toShowExistingPlans = true
    this.toShowForm = false
  }

  onSubmit(){
    if(this.editmode){

      if (this.serviceType.length === 1 && this.serviceType[0] === 'Salon') {
        this.newBusinessObj.entityType = '1';
      } else if (this.serviceType.length === 1 && this.serviceType[0] === 'Beauty Parlour') {
        this.newBusinessObj.entityType = '2';
      } else if (this.serviceType.length === 1 && this.serviceType[0] === 'Spa') {
        this.newBusinessObj.entityType = '3';
      } else if (this.serviceType.length === 1 && this.serviceType[0] === 'Makeup Artist') {
        this.newBusinessObj.entityType = '4';
      } else if (this.serviceType.length === 2 && this.serviceType.includes('Salon') && this.serviceType.includes('Beauty Parlour')) {
        this.newBusinessObj.entityType = '5';
      } else if (this.serviceType.length === 2 && this.serviceType.includes('Salon') && this.serviceType.includes('Spa')) {
        this.newBusinessObj.entityType = '6';
      } else if (this.serviceType.length === 2 && this.serviceType.includes('Salon') && this.serviceType.includes('Makeup Artist')) {
        this.newBusinessObj.entityType = '7';
      } else if (this.serviceType.length === 2 && this.serviceType.includes('Beauty Parlour') && this.serviceType.includes('Spa')) {
        this.newBusinessObj.entityType = '8';
      } else if (this.serviceType.length === 2 && this.serviceType.includes('Beauty Parlour') && this.serviceType.includes('Makeup Artist')) {
        this.newBusinessObj.entityType = '9';
      } else if (this.serviceType.length === 2 && this.serviceType.includes('Spa') && this.serviceType.includes('Makeup Artist')) {
        this.newBusinessObj.entityType = '10';
      } else if (this.serviceType.length === 3 && this.serviceType.includes('Salon') && this.serviceType.includes('Beauty Parlour') && this.serviceType.includes('Spa')) {
        this.newBusinessObj.entityType = '11';
      } else if (this.serviceType.length === 3 && this.serviceType.includes('Salon') && this.serviceType.includes('Beauty Parlour') && this.serviceType.includes('Makeup Artist')) {
        this.newBusinessObj.entityType = '12';
      } else if (this.serviceType.length === 3 && this.serviceType.includes('Salon') && this.serviceType.includes('Spa') && this.serviceType.includes('Makeup Artist')) {
        this.newBusinessObj.entityType = '13';
      } else if (this.serviceType.length === 3 && this.serviceType.includes('Beauty Parlour') && this.serviceType.includes('Spa') && this.serviceType.includes('Makeup Artist')) {
        this.newBusinessObj.entityType = '14';
      } else if (this.serviceType.length === 4 && this.serviceType.includes('Salon') && this.serviceType.includes('Beauty Parlour') && this.serviceType.includes('Spa') && this.serviceType.includes('Makeup Artist')) {
        this.newBusinessObj.entityType = '15';
      }



      let bodyData = {
        entityInfo: {
          hashId: this.parentData.data[0].hashId,
          name: this.newBusinessObj.name,
          phone: this.newBusinessObj.phone,
          entityType: this.newBusinessObj.entityType,
          entityDesc: this.newBusinessObj.entityDesc ? this.newBusinessObj.entityDesc : null,
          referenceNo: this.newBusinessObj.referenceNo,
          ownerName: this.newBusinessObj.ownerName ? this.newBusinessObj.ownerName : null,
          ownerPhone: this.newBusinessObj.ownerPhone ? this.newBusinessObj.ownerPhone : null,
          addressInfo: this.newBusinessObj.addressInfo,
          entityStatus: "1",
          isMediaOnly: 0,
          assetType: this.parentData.data[0].asset_type,
          homeServiceStatus: this.homeServiceAvailable == true ? 1 : 0,
          shopServiceStatus: this.shopServiceAvailable == true ? 1 : 0

        }
      }

      bodyData.entityInfo.addressInfo = {
        addressLine : this.formattedAddress ?  this.formattedAddress :  this.newBusinessObj.addressInfo.addressLine,
        city : (this.selectedLocation.city && this.selectedLocation.city != 'null') ? this.selectedLocation.city : this.newBusinessObj.addressInfo.city,
        state : (this.selectedLocation.state && this.selectedLocation.state != 'null') ? this.selectedLocation.state : this.newBusinessObj.addressInfo.state,
        country : (this.selectedLocation.country && this.selectedLocation.country != 'null') ? this.selectedLocation.country : this.newBusinessObj.addressInfo.country,
        zip : (this.selectedLocation.zip && this.selectedLocation.zip != 'null') ? this.selectedLocation.zip : this.newBusinessObj.addressInfo.zip,
        lat : (this.lat && this.lat != 'null') ? this.lat : this.newBusinessObj.addressInfo.lat,
        lng : (this.lng && this.lng != 'null') ? this.lng : this.newBusinessObj.addressInfo.lng
      }

      console.log(bodyData);
      // Object.keys(bodyData.entityInfo).forEach(key => {
      //   if ((bodyData.entityInfo as any)[key] === null) {
      //     delete (bodyData.entityInfo as any)[key];
          
      //   }
      // });
      this.loaderService.showLoader = true
      this._apiService.updateEntityInfo(bodyData)

    }
    else {
      if (this.serviceType.length === 1 && this.serviceType[0] === 'Salon') {
        this.newBusinessObj.entityType = '1';
      } else if (this.serviceType.length === 1 && this.serviceType[0] === 'Beauty Parlour') {
        this.newBusinessObj.entityType = '2';
      } else if (this.serviceType.length === 1 && this.serviceType[0] === 'Spa') {
        this.newBusinessObj.entityType = '3';
      } else if (this.serviceType.length === 1 && this.serviceType[0] === 'Makeup Artist') {
        this.newBusinessObj.entityType = '4';
      } else if (this.serviceType.length === 2 && this.serviceType.includes('Salon') && this.serviceType.includes('Beauty Parlour')) {
        this.newBusinessObj.entityType = '5';
      } else if (this.serviceType.length === 2 && this.serviceType.includes('Salon') && this.serviceType.includes('Spa')) {
        this.newBusinessObj.entityType = '6';
      } else if (this.serviceType.length === 2 && this.serviceType.includes('Salon') && this.serviceType.includes('Makeup Artist')) {
        this.newBusinessObj.entityType = '7';
      } else if (this.serviceType.length === 2 && this.serviceType.includes('Beauty Parlour') && this.serviceType.includes('Spa')) {
        this.newBusinessObj.entityType = '8';
      } else if (this.serviceType.length === 2 && this.serviceType.includes('Beauty Parlour') && this.serviceType.includes('Makeup Artist')) {
        this.newBusinessObj.entityType = '9';
      } else if (this.serviceType.length === 2 && this.serviceType.includes('Spa') && this.serviceType.includes('Makeup Artist')) {
        this.newBusinessObj.entityType = '10';
      } else if (this.serviceType.length === 3 && this.serviceType.includes('Salon') && this.serviceType.includes('Beauty Parlour') && this.serviceType.includes('Spa')) {
        this.newBusinessObj.entityType = '11';
      } else if (this.serviceType.length === 3 && this.serviceType.includes('Salon') && this.serviceType.includes('Beauty Parlour') && this.serviceType.includes('Makeup Artist')) {
        this.newBusinessObj.entityType = '12';
      } else if (this.serviceType.length === 3 && this.serviceType.includes('Salon') && this.serviceType.includes('Spa') && this.serviceType.includes('Makeup Artist')) {
        this.newBusinessObj.entityType = '13';
      } else if (this.serviceType.length === 3 && this.serviceType.includes('Beauty Parlour') && this.serviceType.includes('Spa') && this.serviceType.includes('Makeup Artist')) {
        this.newBusinessObj.entityType = '14';
      } else if (this.serviceType.length === 4 && this.serviceType.includes('Salon') && this.serviceType.includes('Beauty Parlour') && this.serviceType.includes('Spa') && this.serviceType.includes('Makeup Artist')) {
        this.newBusinessObj.entityType = '15';
      }
      
      this.newBusinessObj.addressInfo = {
        addressLine : this.formattedAddress,
        city : (this.selectedLocation.city && this.selectedLocation.city != 'null') ? this.selectedLocation.city : 'null',
        state : (this.selectedLocation.state && this.selectedLocation.state != 'null') ? this.selectedLocation.state : 'null',
        country : (this.selectedLocation.country && this.selectedLocation.country != 'null') ? this.selectedLocation.country : 'null',
        zip : (this.selectedLocation.zip && this.selectedLocation.zip != 'null') ? this.selectedLocation.zip : 'null',
        lat : (this.lat && this.lat != 'null') ? this.lat : 'null',
        lng : (this.lng && this.lng != 'null') ? this.lng : 'null' 
      }
      // homeServiceStatus: this.homeServiceAvailable == true ? 1 : 0,
      //     shopServiceStatus: this.shopServiceAvailable == true ? 1 : 0

      this.newBusinessObj.homeServiceStatus = this.homeServiceAvailable == true ? 1 : 0  
      let bodyData = {
        entityInfo : this.newBusinessObj
      }
      console.log(bodyData);
      
      this.loaderService.showLoader = true
      this._apiService.updateEntityInfo(bodyData)
    }

    
  }

  selectedPlatformPlan: any = []
  toShowMonths: boolean = false
  onSelectPlan(item:any){
    if(item.isExpired == 0){   
      if(item.validity_count == 30 && item.perUnitCost > 0){

        this.toShowMonths = true
        this.noOfMonths = 1
      } else if(item.validity_count != 30 || item.perUnitCost == 0){
        this.toShowMonths = false
        this.noOfMonths = 1
      } 


      this.plansList.forEach((element:any) => {
        element.selected = false
      });
      item.selected = true
      this.selectedPlan = []
      this.selectedPlan.push(item)
      
      
    }
  
  }

  onContinue(){
    if(this.selectedPlan[0].perUnitCost > 0){

    let data = {
      amount: ((this.selectedPlan[0].perUnitCost*100)*this.noOfMonths).toString(),
      currency: "INR",
      receipt: this.generateReceiptNumber()
    }

    console.log(data);

    this._apiService.createSubscriptionOrder(data)
    
    }else {
      this.paymentResponse = {
        signature: "test"
      }
      let data = {
        transactionInfo: {
          planHash	:	this.selectedPlan[0].hash_id,
          noOfUsers	:	0,
          noOfEntity	:	1,
          fromDate	:	this.formatDateString(new Date()),
          toDate	:	this.addDaysToDate(new Date(), +this.selectedPlan[0].validity.split(' ')[0]),
          validity	:	+this.selectedPlan[0].validity.split(' ')[0],
          totalCost	:	this.selectedPlan[0].perUnitCost,
          unitCost	:	this.selectedPlan[0].perUnitCost,
          paymentType	:	1,
          paymentRef	:	"",
          currency: this.selectedPlan[0].currency,
          currencySymbol: this.selectedPlan[0].currency_symbol,

        }
      }

      this._apiService.updatePaymentRecord(data)
    }


  }

  changeNoOfMonths(value:any){
    if(value == 0)
    {
      this.noOfMonths -= 1
    }else if(value == 1){
      this.noOfMonths += 1
    }
  }

  /**LOCATION AUTOCOMPLETE FUNCTION */
  GoogleAutocomplete = new google.maps.places.AutocompleteService();
  geocoder = new google.maps.Geocoder();
     autocompleteItems:any = [];
     selectedLocation : any = [];
   formattedAddress : any;
   lat:any;
   lng:any;
  updateSearchResults() {
    console.log("Text enter")
    if ( this.newBusinessObj.addressInfo.addressLine == '' || this.newBusinessObj.addressInfo.addressLine == null)
    {
        this.autocompleteItems = [];
        return;
    }
    this.GoogleAutocomplete.getPlacePredictions( {
        input: this.newBusinessObj.addressInfo.addressLine
    },
        ( predictions:any, status:any ) => {
  
          console.log(predictions,status);
            this.autocompleteItems = [];
            predictions.forEach( ( prediction:any ) => {
                this.autocompleteItems.push( prediction );
            } );
        } );
  }
  selectSearchResult( item:any ) {
    console.log(item);
    this.autocompleteItems = [];
    this.geocoder.geocode( {
        'placeId': item.place_id
    }, ( results:any, status:any ) => {
        if ( status === 'OK' && results[ 0 ] )
        {
            this.ngZone.run( () => {
                // this.personalInfoForm.value.address = results[ 0 ].formatted_address;
                this.newBusinessObj.addressInfo.addressLine = results[0].formatted_address
                // this.personalInfoForm.get('address').patchValue(results[0].formatted_address);
                // this.locationSelected = true;
                let location_set:any = JSON.stringify(results[0].geometry);
                location_set=JSON.parse(location_set)
                let position = {
                    lat: results[ 0 ].geometry.location.lat,
                    lng: results[ 0 ].geometry.location.lng
                };
                this.lat=location_set.location.lat;
                this.lng=location_set.location.lng;
                console.log(this.lat,this.lng);
                console.log('Latitude & Langitude' , position)
                this.storeLocation( results[ 0 ].address_components, results[ 0 ].formatted_address );
            } );
        }
    } )
  }
  storeLocation( location:any, formatted_address:any ) {
    console.log(location);
    
    const selectedLocation: any = {};
    location.forEach( (element:any) => {
        console.log( element, element.types.includes( "postal_code" ) )
        if ( element.types.includes( "postal_code" ) )
        {
            selectedLocation.zip = element.long_name
        } else if ( element.types.includes( "country" ) )
        {
            selectedLocation.country = element.long_name
        } else if ( element.types.includes( "administrative_area_level_1" ) )
        {
            selectedLocation.state = element.long_name
        } else if ( element.types.includes( "locality" ) )
        {
            selectedLocation.city = element.long_name
        } else if ( element.types.includes( "route" ) )
        {
            selectedLocation.address = element.long_name
        }
    } );
      this.formattedAddress = formatted_address;
      this.selectedLocation = selectedLocation;
  }

  formatDateString(inputDateString: Date): string {
    const inputDate = new Date(inputDateString);
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
    const day = inputDate.getDate().toString().padStart(2, '0');
    const hours = inputDate.getHours().toString().padStart(2, '0');
    const minutes = inputDate.getMinutes().toString().padStart(2, '0');
    const seconds = inputDate.getSeconds().toString().padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  }

  addDaysToDate(currentDate: Date, daysToAdd: number): string {
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() + daysToAdd);

    const year = newDate.getFullYear();
    const month = String(newDate.getMonth() + 1).padStart(2, '0');
    const day = String(newDate.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

generateReceiptNumber(): string {
  return uuidv4();
}

paymentResponse:any = null
payWithRazor(val:any, amount:any) {
console.log(val, amount);

  const options: any = {

   //OLD KEY
    // key: 'rzp_test_Z3ZWXkX2GZF6Hd',

    //NEW KEY
    key: environment.razorpayKey,

    amount: amount, // amount should be in paise format to display Rs 1255 without decimal point

    currency: 'INR',

    order_id: val, // order_id created by you in backend

    modal: {

      // We should prevent closing of the form when esc key is pressed.

      escape: false,

    },

    theme: {

      color: '#0c238a'

    }

  };

  options.handler = ((response:any, error:any) => {

    options.response = response;

    console.log(response);

    this.paymentResponse = response
    
    this._apiService.validatePaymentSignature(response)

    // call your backend api to verify payment signature & capture transaction

  });

  options.modal.ondismiss = (() => {

    // handle the case when user closes the form while transaction is in progress
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
      data : {
        title : 'Alert',
        message : "The payment process interrupted and couldn't be completed. Try again if not done intentionally.",
        okbtn : 'Ok',
        cancelbtn : 'Ok',
        type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
      },
      disableClose : true
    });
    console.log('Transaction cancelled.');

  });

  const rzp = new this.winRef.nativeWindow.Razorpay(options); 

  rzp.open();

}

forceUpdate() {
  console.log("myomy");
  
  this.cdr.detectChanges();
}
simulateMouseClick(element:any) {
  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true
  });

  element.dispatchEvent(clickEvent);
}

ngOnDestroy(): void {
  this._apiSubscription.unsubscribe()
}
}


